import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({
  theme,
  alignCenter,
  centered,
  fullHeight,
  negativeSideMargin,
  nowrap,
  justifyContent,
  direction,
}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  extend: [
    {
      condition: direction,
      style: {
        flexDirection: direction,
      },
    },
    {
      condition: alignCenter,
      style: {
        alignItems: 'center',
      },
    },
    {
      condition: centered,
      style: {
        justifyContent: 'center',
      },
    },
    {
      condition: fullHeight,
      style: {
        height: '100%',
      },
    },
    {
      condition: justifyContent,
      style: {
        justifyContent,
      },
    },
    {
      condition: negativeSideMargin,
      style: {
        marginLeft: `-${theme.margin[negativeSideMargin]}`,
        marginRight: `-${theme.margin[negativeSideMargin]}`,
      },
    },
    {
      condition: nowrap,
      style: {
        flexWrap: 'nowrap',
      },
    },
  ],
});

const Row = (props) => {
  const {
    alignCenter, centered, fullHeight, negativeSideMargin, justifyContent, nowrap, direction, children,
  } = props;
  const { css } = useFela({
    alignCenter,
    centered,
    fullHeight,
    negativeSideMargin,
    justifyContent,
    nowrap,
    direction,
  });

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

Row.propTypes = {
  alignCenter: PropTypes.bool,
  centered: PropTypes.bool,
  fullHeight: PropTypes.bool,
  negativeSideMargin: PropTypes.string,
  justifyContent: PropTypes.string,
  nowrap: PropTypes.bool,
  direction: PropTypes.string,
  children: PropTypes.node,
};

export default React.memo(Row);
